export default {
  LOAD_SHOP_OPEN_TIME: 'set shop open time',
  /**
   * USER
   */
  SET_USER: 'set fb or google signed in user',
  CLEAR_USER: "clear user's data",
  /**
   * ADMIN
   */
  SET_ADMIN: 'set admin user',
  CLEAR_ADMIN: "clear user's data",
  /**
   * Component control action types
   */
  OPEN_MODAL: 'open admin login modal',
  CLOSE_MODEL: 'close admin login modal',
}
